import type { ContentBlock } from 'draft-js';

export const cellBlockStyleFn = (contentBlock: ContentBlock): string => {
  const type = contentBlock.getType();
  const classes = [];

  if (type === 'blockquote') {
    // eslint-disable-next-line fp/no-mutating-methods
    classes.push('cellBlockQuote');
  } else if (type === 'unordered-list-item' || type === 'ordered-list-item') {
    // eslint-disable-next-line fp/no-mutating-methods
    classes.push('cellListItem');
  }

  return classes.join(' ');
};
